import { createBrowserRouter, Navigate } from "react-router-dom";
import { AppShell } from "@/layout/AppShell";
import { ExecutivePage } from "@/pages/ExecutivePage";
import { ArchitecturePage } from "@/pages/ArchitecturePage";
import { UmsetzungsgradPage } from "@/pages/UmsetzungsgradPage";
import { ArtifactsPage } from "@/pages/ArtifactsPage";
import { ArtifactTypePage } from "@/pages/ArtifactTypePage";
import { ActivityPage } from "@/pages/ActivityPage";
import { NewRunPage } from "@/pages/NewRunPage";
import { RunDetailPage } from "@/pages/RunDetailPage";
import { ChangelogPage } from "@/pages/ChangelogPage";
import { ReviewQueuePage } from "@/pages/ReviewQueuePage";
import { ValidatorPage } from "@/pages/Validator/ValidatorPage";
import { ConditionsOverview } from "@/pages/Validator/ConditionsOverview";
import { MappingPage } from "@/pages/Mapping/MappingPage";
import { EbdViewerPage } from "@/pages/Ebd/EbdViewerPage";
import { PruefidViewerPage } from "@/pages/Pruefid/PruefidViewerPage";
import { VergleichPage } from "@/pages/Regelwerk/VergleichPage";
import { TabellenPage } from "@/pages/Regelwerk/TabellenPage";
import { BedingungenPage } from "@/pages/Regelwerk/BedingungenPage";
import { FormatZeitleistePage } from "@/pages/Regelwerk/FormatZeitleistePage";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <AppShell />,
    children: [
      { index: true, element: <ExecutivePage /> },
      { path: "executive", element: <Navigate to="/" replace /> },
      { path: "architecture", element: <ArchitecturePage /> },
      { path: "architecture/:componentId", element: <ArchitecturePage /> },
      // Dieselbe Übersicht, plus Ziele — die Komponenten-Route ist dieselbe
      // Mechanik wie unter /architecture, nur unter eigenem Präfix.
      { path: "umsetzungsgrad", element: <UmsetzungsgradPage /> },
      { path: "umsetzungsgrad/:componentId", element: <UmsetzungsgradPage /> },
      { path: "artifacts", element: <ArtifactsPage /> },
      { path: "artifacts/:type", element: <ArtifactTypePage /> },
      { path: "artifacts/:type/:release", element: <ArtifactTypePage /> },
      // Runs, Queue und Autoruns sind EINE Zeitachse (`/activity`). Die drei
      // alten Listen-Pfade bleiben als Umleitung bestehen: Lesezeichen und
      // fremde Links dürfen nicht ins Leere laufen. `replace`, damit der
      // Zurück-Knopf nicht in der Umleitung hängen bleibt.
      { path: "activity", element: <ActivityPage /> },
      { path: "runs", element: <Navigate to="/activity" replace /> },
      { path: "queue", element: <Navigate to="/activity" replace /> },
      { path: "autoruns", element: <Navigate to="/activity" replace /> },
      // Einzelner Lauf und „Neuer Run" bleiben eigene Seiten — die Zeitachse
      // verlinkt auf `/runs/:runId`, der Kopf auf `/runs/new`.
      { path: "runs/new", element: <NewRunPage /> },
      { path: "runs/:runId", element: <RunDetailPage /> },
      { path: "review", element: <ReviewQueuePage /> },
      { path: "review/:runId", element: <ReviewQueuePage /> },
      { path: "changelog", element: <ChangelogPage /> },
      { path: "regelwerk/vergleich", element: <VergleichPage /> },
      { path: "regelwerk/tabellen", element: <TabellenPage /> },
      { path: "regelwerk/bedingungen", element: <BedingungenPage /> },
      { path: "regelwerk/zeitleiste", element: <FormatZeitleistePage /> },
      { path: "validator", element: <ValidatorPage /> },
      { path: "validator/conditions", element: <ConditionsOverview /> },
      { path: "mapping", element: <MappingPage /> },
      { path: "ebd", element: <EbdViewerPage /> },
      { path: "ebd/:release/:code", element: <EbdViewerPage /> },
      { path: "pruefid", element: <PruefidViewerPage /> },
      { path: "pruefid/:release", element: <PruefidViewerPage /> },
    ],
  },
]);
